import { render, staticRenderFns } from "./locationLaunchDetails.vue?vue&type=template&id=00396647&scoped=true"
import script from "./locationLaunchDetails.vue?vue&type=script&lang=js"
export * from "./locationLaunchDetails.vue?vue&type=script&lang=js"
import style0 from "./locationLaunchDetails.vue?vue&type=style&index=0&id=00396647&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00396647",
  null
  
)

export default component.exports